import { environment } from "../../environments/environment";

export const BASE_URL = environment.baseUrl;
export const SOCKET_URL = environment.socketUrl;

export const API_PRODUCTIONV2_URL = BASE_URL + '/productionv2'
export const API_USERS_URL = BASE_URL+'/user';
export const API_PAVILIONS_URL = BASE_URL+'/pavilion';
export const API_SILOS_URL = BASE_URL + '/silo'
export const API_MACHINE_URL = BASE_URL + '/machinev2'
export const API_MACHINE_TYPE_URL = BASE_URL + '/machinev2/type'
export const API_MACHINE_TECH_TYPE_URL = BASE_URL + '/machinev2/tech/type'
export const API_MACHINE_SENSOR_URL = BASE_URL + '/machinev2/sensor'
export const API_MACHINE_SENSOR_PORT_URL = BASE_URL + '/machinev2/sensor/port'
export const API_QUARTEL_URL = BASE_URL + '/quartel'
export const API_WEIGHT_METER_URL = BASE_URL + '/weight-meter'
export const API_PRODUCT_URL = BASE_URL + '/product'
export const API_PRODUCT_TYPE_URL = BASE_URL + '/product/type'
export const API_PRODUCT_PACKAGE_WEIGHT_URL = BASE_URL + '/product/package/weight'
export const API_PRODUCT_PACKAGE_UNIT_URL = BASE_URL + '/product/package/unit'
export const API_PRODUCT_PACKAGE_URL = BASE_URL + '/product/package'
export const API_PRODUCT_PROCESS_URL = BASE_URL + '/product/process'
export const API_SHIFT_URL = BASE_URL + '/shift'
export const API_BIRDS_URL = BASE_URL + '/bird'
export const API_GRAIN_TYPE_URL = BASE_URL + '/grain-type'
export const API_ALARMS_URL = BASE_URL+'/alarms';
export const API_PERMISSION_URL = 'api/permissions';
export const API_ROLES_URL = 'api/roles';
export const API_PRODUCTION_URL = BASE_URL + '/production';
export const API_COMPANY_URL = BASE_URL + '/company';
export const API_PLANT_URL = BASE_URL + '/plant';
export const API_PARTNER_URL = BASE_URL + '/partner';
export const API_OPERATOR_URL = BASE_URL + '/operator';
export const API_THEME_URL = BASE_URL + '/theme';
export const API_MODULE_URL = BASE_URL + '/module';
export const API_GROUP_URL = BASE_URL + '/group';
export const API_EMAIL_REPORT_TYPE_URL = BASE_URL + '/report/email/type';
export const API_CSV_REPORT_TYPE_URL = BASE_URL + '/report/csv/type';
export const API_CSV_REPORT_STATUS_URL = BASE_URL + '/report/csv/status';
export const API_CSV_REPORT_INT_URL = BASE_URL + '/report/csv/int';
export const API_CSV_REPORT_PERIODICITY_URL = BASE_URL + '/report/csv/periodicity';
export const API_CSV_REPORT_CFG_URL = BASE_URL + '/report/csv/cfg';
export const API_CSV_REPORT_URL = BASE_URL + '/report/csv';
export const API_EMAIL_REPORT_STATUS_URL = BASE_URL + '/report/email/status';
export const API_EMAIL_TEMPLATE_CFG_URL = BASE_URL + '/report/email/template/cfg';
export const API_EMAIL_TEMPLATE_MASTER_URL = BASE_URL + '/report/email/template';
export const API_EMAIL_REPORT_CFG_URL = BASE_URL + '/report/email/cfg';
export const API_SHIFT_EMAIL_REPORT_URL = BASE_URL + '/report/shift-email';
export const API_PRODUCTION_LINE_URL = BASE_URL + '/production-line';
export const API_DETENTION_TYPE_URL = BASE_URL + '/detention-type';
export const API_DETENTION_URL = BASE_URL + '/detention';
export const API_DETENTIONV2_URL = BASE_URL + '/detentionv2';
export const API_ALARM_URL = BASE_URL + '/alarm';
export const API_ALARM_STATUS_URL = BASE_URL + '/alarm/status';
export const API_ALARM_CFG_URL = BASE_URL + '/alarm/cfg';
export const API_ALARM_CRITICALITY_URL = BASE_URL + '/alarm/criticality';
export const API_ALARM_TYPE_URL = BASE_URL + '/alarm/type';
export const API_ALARM_DATA_TYPE_URL = BASE_URL + '/alarm/data-type';
export const API_ALARM_NOTIFICATION_LIST_URL = BASE_URL + '/alarm/notification/list';
export const API_ALARM_NOTIFICATION_TYPE_URL = BASE_URL + '/alarm/notification/type';
export const API_ALARM_NOTIFICATION_CFG_URL = BASE_URL + '/alarm/notification/cfg';
export const API_ALARM_NOTIFICATION_PERIODICITY_TYPE_URL = BASE_URL + '/alarm/notification/periodicity';
export const API_QUALITY_URL = BASE_URL + '/quality';
export const API_QUALITY_TYPE_URL = BASE_URL + '/quality/type';
export const API_MANUAL_DATA_URL = BASE_URL + '/manual/data';
export const API_MANUAL_DATA_STATUS_URL = BASE_URL + '/manual/data/status';
export const API_PRODUCTV2_URL = BASE_URL + '/productv2'
export const API_PRODUCT_SESSION_URL = BASE_URL + '/product/session'
export const API_SHIFT_SESSION_URL = BASE_URL + '/shift/session'
// Catálogos v1.29 usados para resolver las relaciones de Data Manual.
export const API_WORK_ORDER_URL = BASE_URL + '/work/order'
export const API_LOT_URL = BASE_URL + '/lot'
